import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetScreenerQuestionLabelDataQueryVariables = Types.Exact<{
    applicationDraftId: Types.Scalars['ID']['input'];
}>;

export type GetScreenerQuestionLabelDataQuery = {
    __typename?: 'Query';
    findApplicationDrafts?:
        | {
              __typename?: 'FindApplicationDraftsConnection';
              operationDetails: Array<{
                  __typename?: 'DraftManagementApplicationDraft';
                  applicationDraftId: string;
                  questionsAndAnswers?:
                      | {
                            __typename?: 'DraftManagementQuestionsAndAnswers';
                            screener: Array<{
                                __typename?: 'DraftManagementQuestionAndAnswer';
                                question: {
                                    __typename?: 'DraftManagementQuestion';
                                    questionId: string;
                                };
                            }>;
                        }
                      | null
                      | undefined;
              }>;
          }
        | null
        | undefined;
};

export type GetScreenerQuestionLabelDataWithDqQueryVariables = Types.Exact<{
    applicationDraftId: Types.Scalars['ID']['input'];
}>;

export type GetScreenerQuestionLabelDataWithDqQuery = {
    __typename?: 'Query';
    findApplicationDrafts?:
        | {
              __typename?: 'FindApplicationDraftsConnection';
              operationDetails: Array<{
                  __typename?: 'DraftManagementApplicationDraft';
                  applicationDraftId: string;
                  questionsAndAnswers?:
                      | {
                            __typename?: 'DraftManagementQuestionsAndAnswers';
                            screener: Array<{
                                __typename?: 'DraftManagementQuestionAndAnswer';
                                question: {
                                    __typename?: 'DraftManagementQuestion';
                                    questionId: string;
                                };
                            }>;
                            demographic: Array<{
                                __typename?: 'DraftManagementQuestionAndAnswer';
                                question: {
                                    __typename?: 'DraftManagementQuestion';
                                    questionId: string;
                                };
                            }>;
                        }
                      | null
                      | undefined;
              }>;
          }
        | null
        | undefined;
};

export const GetScreenerQuestionLabelDataDocument = gql`
    query GetScreenerQuestionLabelData($applicationDraftId: ID!) {
        findApplicationDrafts(
            input: { filter: { applicationDraftId: $applicationDraftId } }
            first: 1
        ) {
            operationDetails {
                applicationDraftId
                questionsAndAnswers {
                    screener {
                        question {
                            questionId
                        }
                    }
                }
            }
        }
    }
`;

/**
 * __useGetScreenerQuestionLabelDataQuery__
 *
 * To run a query within a React component, call `useGetScreenerQuestionLabelDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenerQuestionLabelDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenerQuestionLabelDataQuery({
 *   variables: {
 *      applicationDraftId: // value for 'applicationDraftId'
 *   },
 * });
 */
export function useGetScreenerQuestionLabelDataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetScreenerQuestionLabelDataQuery,
        GetScreenerQuestionLabelDataQueryVariables
    > &
        (
            | { variables: GetScreenerQuestionLabelDataQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetScreenerQuestionLabelDataQuery,
        GetScreenerQuestionLabelDataQueryVariables
    >(GetScreenerQuestionLabelDataDocument, options);
}
export function useGetScreenerQuestionLabelDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetScreenerQuestionLabelDataQuery,
        GetScreenerQuestionLabelDataQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetScreenerQuestionLabelDataQuery,
        GetScreenerQuestionLabelDataQueryVariables
    >(GetScreenerQuestionLabelDataDocument, options);
}
export function useGetScreenerQuestionLabelDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetScreenerQuestionLabelDataQuery,
              GetScreenerQuestionLabelDataQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetScreenerQuestionLabelDataQuery,
        GetScreenerQuestionLabelDataQueryVariables
    >(GetScreenerQuestionLabelDataDocument, options);
}
export type GetScreenerQuestionLabelDataQueryHookResult = ReturnType<
    typeof useGetScreenerQuestionLabelDataQuery
>;
export type GetScreenerQuestionLabelDataLazyQueryHookResult = ReturnType<
    typeof useGetScreenerQuestionLabelDataLazyQuery
>;
export type GetScreenerQuestionLabelDataSuspenseQueryHookResult = ReturnType<
    typeof useGetScreenerQuestionLabelDataSuspenseQuery
>;
export type GetScreenerQuestionLabelDataQueryResult = Apollo.QueryResult<
    GetScreenerQuestionLabelDataQuery,
    GetScreenerQuestionLabelDataQueryVariables
>;
export const GetScreenerQuestionLabelDataWithDqDocument = gql`
    query GetScreenerQuestionLabelDataWithDq($applicationDraftId: ID!) {
        findApplicationDrafts(
            input: { filter: { applicationDraftId: $applicationDraftId } }
            first: 1
        ) {
            operationDetails {
                applicationDraftId
                questionsAndAnswers {
                    screener {
                        question {
                            questionId
                        }
                    }
                    demographic {
                        question {
                            questionId
                        }
                    }
                }
            }
        }
    }
`;

/**
 * __useGetScreenerQuestionLabelDataWithDqQuery__
 *
 * To run a query within a React component, call `useGetScreenerQuestionLabelDataWithDqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenerQuestionLabelDataWithDqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenerQuestionLabelDataWithDqQuery({
 *   variables: {
 *      applicationDraftId: // value for 'applicationDraftId'
 *   },
 * });
 */
export function useGetScreenerQuestionLabelDataWithDqQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetScreenerQuestionLabelDataWithDqQuery,
        GetScreenerQuestionLabelDataWithDqQueryVariables
    > &
        (
            | { variables: GetScreenerQuestionLabelDataWithDqQueryVariables; skip?: boolean }
            | { skip: boolean }
        ),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetScreenerQuestionLabelDataWithDqQuery,
        GetScreenerQuestionLabelDataWithDqQueryVariables
    >(GetScreenerQuestionLabelDataWithDqDocument, options);
}
export function useGetScreenerQuestionLabelDataWithDqLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetScreenerQuestionLabelDataWithDqQuery,
        GetScreenerQuestionLabelDataWithDqQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetScreenerQuestionLabelDataWithDqQuery,
        GetScreenerQuestionLabelDataWithDqQueryVariables
    >(GetScreenerQuestionLabelDataWithDqDocument, options);
}
export function useGetScreenerQuestionLabelDataWithDqSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetScreenerQuestionLabelDataWithDqQuery,
              GetScreenerQuestionLabelDataWithDqQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetScreenerQuestionLabelDataWithDqQuery,
        GetScreenerQuestionLabelDataWithDqQueryVariables
    >(GetScreenerQuestionLabelDataWithDqDocument, options);
}
export type GetScreenerQuestionLabelDataWithDqQueryHookResult = ReturnType<
    typeof useGetScreenerQuestionLabelDataWithDqQuery
>;
export type GetScreenerQuestionLabelDataWithDqLazyQueryHookResult = ReturnType<
    typeof useGetScreenerQuestionLabelDataWithDqLazyQuery
>;
export type GetScreenerQuestionLabelDataWithDqSuspenseQueryHookResult = ReturnType<
    typeof useGetScreenerQuestionLabelDataWithDqSuspenseQuery
>;
export type GetScreenerQuestionLabelDataWithDqQueryResult = Apollo.QueryResult<
    GetScreenerQuestionLabelDataWithDqQuery,
    GetScreenerQuestionLabelDataWithDqQueryVariables
>;
